const CNPJ_REGISTRATION_TYPES = new Set(["2", "3", "4"]);

export function normalizeCnpj(value) {
  return String(value ?? "")
    .replace(/[^a-zA-Z0-9]/g, "")
    .toUpperCase();
}

export function requiresCnpjVerification(registrationType) {
  return CNPJ_REGISTRATION_TYPES.has(String(registrationType ?? ""));
}

export function canAccessRegistrationDetails(
  registrationType,
  currentCnpj,
  verifiedCnpj,
) {
  if (!requiresCnpjVerification(registrationType)) {
    return true;
  }

  const normalizedCurrentCnpj = normalizeCnpj(currentCnpj);
  const normalizedVerifiedCnpj = normalizeCnpj(verifiedCnpj);

  return (
    normalizedCurrentCnpj.length > 0 &&
    normalizedCurrentCnpj === normalizedVerifiedCnpj
  );
}

export function keepVerifiedCnpjForCurrentInput(currentCnpj, verifiedCnpj) {
  if (
    normalizeCnpj(currentCnpj) !== normalizeCnpj(verifiedCnpj) ||
    !normalizeCnpj(currentCnpj)
  ) {
    return "";
  }

  return verifiedCnpj;
}

export function getCnpjVerificationFeedback(cnpj, captchaToken) {
  if (normalizeCnpj(cnpj) && !captchaToken) {
    return {
      icon: "warning",
      title: "Verificação necessária",
      text: "Conclua a verificação de segurança para consultar o CNPJ.",
    };
  }

  return null;
}

export function hasCnpjLookupResult(responseData) {
  return Boolean(responseData?.RazaoSocial?.trim());
}
